<div class="loc-container"
     [class.loc-table-collapsed]="isLocationTableCollapsed">

  <!-- Top: Location list table -->
  <div class="loc-table-section">
    <div class="loc-table-toolbar">
      <ui-form-field
        class="loc-search-box"
        type="text"
        [prefixIcon]="'search'"
        [placeholder]="'customers.location_tab.search_placeholder' | translate"
        [formControl]="locationSearchInput"
        autocomplete="off"
      ></ui-form-field>
      <div class="loc-source-filter">
        <button class="loc-source-filter-btn" [class.active]="sourceFilter === 'all'" (click)="setSourceFilter('all')">{{ 'customers.location_tab.filter_all' | translate }}</button>
        <button class="loc-source-filter-btn loc-source-filter-erp" [class.active]="sourceFilter === 'erp'" (click)="setSourceFilter('erp')">{{ 'customers.contacts_tab.location_source_erp' | translate }}</button>
        <button class="loc-source-filter-btn loc-source-filter-volta" [class.active]="sourceFilter === 'volta'" (click)="setSourceFilter('volta')">{{ 'customers.contacts_tab.location_source_volta' | translate }}</button>
      </div>
      <button class="action-btn secondary-btn loc-add-btn" type="button"
        *appHasPermission="{ module: 'company', action: 'edit' }"
        (click)="addLocation.emit()">
        <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
        <span class="loc-add-label">{{ "common.location" | translate | uppercase }}</span>
      </button>
    </div>

    <div class="loc-table-wrapper">
      <div class="loc-table-header loc-grid">
        <div class="loc-th">{{ "common.name" | translate }}</div>
        <div class="loc-th">{{ 'customers.location_tab.address_header' | translate }}</div>
        <div class="loc-th">{{ 'common.type' | translate }}</div>
        <div class="loc-th"></div>
      </div>

      <div class="loc-table-body" (scroll)="onLocationsScroll($event)">
        <div class="loc-table-row loc-grid"
             *ngFor="let row of visibleLocations; trackBy: trackLocationRow"
             [class.loc-row-active]="row.location.id === selectedLocationId"
             (click)="onLocationRowClick(row)">
          <div class="loc-cell loc-cell-name">
            <span class="loc-name-text">{{ row.location.name }}</span>
            <span class="loc-main-badge" *ngIf="row.location.is_main">{{ 'customers.main' | translate }}</span>
            <span
              *ngIf="row.location.provenance?.source === 'volta'"
              class="volta-location-icon"
              [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
              matTooltipClass="product-status-tooltip volta-location-tooltip"
              matTooltipPosition="above"
            >
              <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
            </span>
          </div>
          <div class="loc-cell loc-cell-addr" [title]="row.address">{{ row.address || '--' }}</div>
          <div class="loc-cell">{{ row.type }}</div>
          <div class="loc-cell loc-cell-actions">
            <button class="loc-row-more-btn" type="button"
                    *ngIf="(canEdit$ | async) || (canDelete$ | async)"
                    [matMenuTriggerFor]="locationRowMenu"
                    (click)="$event.stopPropagation()"
                    [matTooltip]="'customers.location_tab.more_actions' | translate">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #locationRowMenu="matMenu" class="loc-row-actions-menu">
              <button mat-menu-item type="button"
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      (click)="editLocation.emit(row.location)">
                <mat-icon>edit</mat-icon>
                <span>{{ 'common.edit' | translate }}</span>
              </button>
              <button mat-menu-item type="button" class="loc-row-delete-item"
                      *appHasPermission="{ module: 'company', action: 'delete' }"
                      (click)="deleteLocation.emit(row.location)">
                <mat-icon>delete_outline</mat-icon>
                <span>{{ 'common.delete' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </div>

        <div class="loc-empty" *ngIf="!visibleLocations.length">
          {{ locationSearchInput.value ? ('customers.location_tab.no_locations_match' | translate) : ('customers.location_tab.no_locations_available' | translate) }}
        </div>

        <div class="loc-load-more" *ngIf="isLoadingMore">
          <app-svg-icon svgIcon="eclipse"></app-svg-icon>
          <span>{{ 'common.loading' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Chevron toggle bar (between table and map) -->
  <button class="loc-toggle-bar" type="button" (click)="toggleLocationTable()">
    <span class="loc-toggle-label">
      {{ 'customers.location_tab.map_label' | translate }}
    </span>
    <mat-icon class="loc-toggle-chevron"
              [class.loc-chevron-up]="isLocationTableCollapsed">
      keyboard_arrow_down
    </mat-icon>
  </button>

  <!-- Bottom: Map (collapsible) -->
  <div class="loc-map-section">
    <div class="loc-map-loader-overlay" *ngIf="isGeocoding">
    </div>

    <div class="loc-map-wrapper">
      <div #olMap class="loc-map"></div>

      <!-- Legend (anchored top-right inside the map canvas) -->
      <div class="loc-legend" *ngIf="locationTypeCounts.length > 0">
        <span class="loc-legend-title">{{ 'customers.location_tab.legend_label' | translate }}</span>
        <div class="loc-legend-items">
          <label class="loc-legend-item" *ngFor="let entry of locationTypeCounts"
                 (click)="toggleLocationType(entry.type)">
            <span class="loc-legend-swatch" [style.background]="entry.visible ? entry.color : '#ccc'"></span>
            <span class="loc-legend-label">{{ entry.type }}</span>
            <span class="loc-legend-count">({{ entry.count }})</span>
          </label>
        </div>
      </div>

      <!-- Popup overlay -->
      <div #mapPopup class="loc-popup" [class.loc-popup-hidden]="!popupData">
        <button class="loc-popup-close" (click)="closeMapPopup()">×</button>
        <div class="loc-popup-content" *ngIf="popupData">
          <div class="loc-popup-title-row">
            <span class="loc-popup-title">{{ popupData.name }}</span>
            <span class="loc-popup-main-badge" *ngIf="popupData.isMain">{{ 'customers.main' | translate }}</span>
            <span
              *ngIf="popupData.source === 'volta'"
              class="volta-location-icon"
              [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
              matTooltipClass="product-status-tooltip volta-location-tooltip"
              matTooltipPosition="above"
            >
              <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
            </span>
          </div>
          <div class="loc-popup-row">
            <span class="loc-popup-label">{{ 'common.type' | translate }}</span>
            <span class="loc-popup-value">{{ popupData.type }}</span>
          </div>
          <div class="loc-popup-row" *ngIf="popupData.street">
            <span class="loc-popup-label">{{ 'customers.location_tab.popup_street' | translate }}</span>
            <span class="loc-popup-value">{{ popupData.street }}</span>
          </div>
          <div class="loc-popup-row" *ngIf="popupData.city">
            <span class="loc-popup-label">{{ 'customers.location_tab.popup_city' | translate }}</span>
            <span class="loc-popup-value">{{ popupData.city }}</span>
          </div>
          <div class="loc-popup-row" *ngIf="popupData.country">
            <span class="loc-popup-label">{{ 'customers.location_tab.popup_country' | translate }}</span>
            <span class="loc-popup-value">{{ popupData.country }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
